<template>
    <div class="MsgWrap">

        <div class="loading-spinner" v-if="isLoading">
            <base-spinner></base-spinner>
        </div>

        <!-- 항목 테이블 -->
        <div class="tbl_wrap" v-else>

            <div class="counter">
                <div>
                    <base-button-sm mode="btn-white" >
                        <img src="@/assets/imgs/icon/x.png" > 친구해제
                    </base-button-sm>

                </div>
                <div class="search">
                    <form @submit.prevent="getFriends()">
                        <input type="text"
                        v-model="searchNic"
                        placeholder="친구닉네임">
                        <base-button-sm  >검색 </base-button-sm>
                    </form>
                </div>
            </div>
            <table class="tbl">
                <colgroup v-if="!isMobile">
                    <col style="width:5%" />
                    <col style="width:20%" />
                    <col style="*" />
                    <col style="width:20%" />
                </colgroup>
                <colgroup v-else>
                    <col style="width:15%" />
                    <col style="width:40%" />
                    <col style="*" />
                    <col style="width:20%" />
                </colgroup>
                <thead>
                    <tr>
                        <th>
                            <base-checkbox checkvalue="all"  @click="icheck($event)"/>
                        </th>
                        <th>친구닉네임</th>
                        <th>접속상태</th>
                        <th>등록일</th>
                    </tr>
                </thead>
                <tbody>
                    <template v-if="friendLists.data.length > 0">
                        <tr v-for="(list, index) in friendLists.data" :key="index">
                            <td><base-checkbox :checkvalue="list.id"  @click="icheck($event)"/></td>
                            <td class="article_writer">                               
                                <user-name-tag
                                    :user="list.friend"
                                    :displaymytalk="false"
                                    :displayProfileImage="false"
                                    />        
                            </td>
                            <td class="cont onoff" :class="{online:onNoff(list.friend_id)==='온라인'}"> {{onNoff(list.friend_id)}}</td>
                            <td><display-time :time="list.created_at"/></td>
                        </tr>
                    </template>
                    <template v-else>
                        <tr>
                            <td colspan="4" class="txt-center">등록된 친구가 없습니다.</td>
                        </tr>
                    </template>
                </tbody>

            </table>
            <div class="paging">
                <paginate store="friend" collection="friends"  @paging="getFriends" :isMobile="isMobile"/>
            </div>            
        </div>

    </div>
</template>
<script>
import { auth } from '@/components/mixins/auth.js';
import { icheck } from '@/components/mixins/icheck.js';
import DisplayTime from '@/components/site/parts/DisplayTime.vue';
import Paginate from '@/components/site/parts/PaginatePublic.vue'
import { mapGetters } from 'vuex';
export default {
    name:'message_friend'
    ,
    props:{
        userNic:{},
        isMobile:{default:false}
        },
    data(){
        return{
            isLoading:true,
            page:1,
            searchNic:''
        }
    },
    components:{
        DisplayTime,
        Paginate
    },
    mixins:[ auth,icheck],
    mounted(){
        this.getFriends();
    },
    computed:{
        ...mapGetters({
            friendLists:'friend/getFriends',
            connectionUsers: 'users/getConnetionUsers'
        }),
    },
    methods:{
        async getFriends(pagenumber,type){
            const formData = {
                user_id:this.user.id,
                page:pagenumber?pagenumber:1,
                type:type,
                friend_nic:this.searchNic
            }
            const response = await this.$store.dispatch("friend/getFriends", formData);
            console.log(response);

            this.isLoading= false;
            this.isLoadMore = false;
            if(this.lastPage <= this.page)
            {
                //alert('더이상 데이터가 없습니다.');
                this.moreData = false;

            }
        },
        onNoff(userId)
        {
            if(this.connectionUsers.some((user)=>user.id === userId))
            {
                return '온라인';
            }else{
                return '오프라인';
            }
        }
    }
}
</script>
<style lang="scss" scoped>
@import "@/assets/scss/ani_slide";
@import '@/assets/scss/table';
@import '@/assets/scss/message';
.MsgWrap .tbl_wrap .cont{
    color:#ccc;
}
.online{
    color:black !important;
    font-weight:bold;
}
</style>
